
import { computed, defineComponent } from 'vue'

const colors = ['secondary', 'danger', 'success', 'warning', 'info', 'light', 'dark']

export default defineComponent({
  name: 'Alert',
  props: {
    color: {
      type: String,
      validate: (value: string) => colors.includes(value),
    },
  },
  setup(props) {
    const classes = computed(() => {
      const c = ['ui-alert']
      if (props.color) {
        c.push(`ui-alert--${props.color}`)
      }
      return c
    })
    return { classes }
  },
})
